import { FieldConfig, FieldRules, FieldRulesConfig } from '@/types/form'

export interface DeliveryLocationTypeFormState {
  name: string
  charge: number
  status: 'active' | 'inactive'
}

export const deliveryLocationTypeFields: (keyof DeliveryLocationTypeFormState)[] = [
  'name',
  'charge',
  'status',
]

interface DeliveryLocationTypeFieldsConfig extends FieldConfig<{
  name: FieldRules<DeliveryLocationTypeFormState['name']>
  charge: FieldRules<DeliveryLocationTypeFormState['charge']>
  status: FieldRules<DeliveryLocationTypeFormState['status']>
}> {}

interface DeliveryLocationTypeFieldsConfigProps extends FieldRulesConfig<DeliveryLocationTypeFormState> {}

export function deliveryLocationTypeFieldsConfig(
  _props: DeliveryLocationTypeFieldsConfigProps
): DeliveryLocationTypeFieldsConfig {
  return {
    fields: {
      name: {
        rules: {
          required: 'Name is required',
        },
      },
      charge: {
        rules: {
          required: 'Charge is required',
          min: { value: 0, message: 'Charge cannot be negative' },
        },
      },
      status: {
        rules: {
          required: 'Status is required',
        },
      },
    },
  }
}
